import React from "react";
import { Link } from "react-router-dom";
import * as Constants from "../../../constants/Constants";
import { Col } from "react-bootstrap";
import Cookie from "js-cookie";

class VendorOnboardConfirmation extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Col className="venOBConfirmationMain top-30" md={12}>
        <h2 className="userConfirmation">
          {Constants.VOB_THANK_YOU}{Constants.COMMA} {Cookie.get("userName")}
          {Constants.EXCLAMATION}
        </h2>
        <p className="confirmationText">
          {Constants.VOB_CONF_MESSAGE_PART1}
          <span className="confirmationTextBold">
            {Constants.VOB_CONF_MESSAGE_PART2}
          </span>
          {Constants.VOB_CONF_MESSAGE_PART3}
        </p>
        <p className="confirmationText">
          {Constants.VOB_CONF_MESSAGE_PART4}
        </p>
          <Col className="macysHome" md={2}>
            <Link
              className="textDecoration"
              id={Constants.VOB_HOME_ID}
              to={Constants.VP_DEFAULT_HOME_PAGE_URL}
            >
              {Constants.MACYS_HOME}
            </Link>
          </Col>
      </Col>
    );
  } 
}

export default VendorOnboardConfirmation;
